import { documentService } from './window.utils';
import useSitecoreContext from '../hooks/useSitecoreContext';

function parseHTML(html) {
  const divElement = documentService()?.createElement?.('div');
  if (!divElement) return;
  divElement.innerHTML = html;
  return divElement;
}
function serializeHTML(element) {
  const container = documentService()?.createElement?.('div');
  if (!container) return;
  container.appendChild(element.cloneNode(true));
  return container?.innerHTML;
}

function useAppendRootToRichTextInternalLinks(richText?: string) {
  const {sitecoreContext} = useSitecoreContext();
  const hostAppRoot: string | undefined = sitecoreContext?.hostAppRoot;
  if (!richText || !hostAppRoot) return richText;

  const baseUrl: string = hostAppRoot.endsWith('/') ? hostAppRoot.slice(0, -1) : hostAppRoot;
  const parsedHTML = parseHTML(richText);
  const anchorTagArr = parsedHTML?.getElementsByTagName?.('a') as HTMLCollectionOf<HTMLAnchorElement>;
  if (!anchorTagArr) return richText;

  const anchorTags = Array.from(anchorTagArr);

  for (const anchorTag of anchorTags) {
    const href = anchorTag?.getAttribute?.('href');
    if (href?.startsWith('/')) {
      anchorTag?.setAttribute?.('href', `${baseUrl}${href}`);
    }
  }

  const serializedHTML = serializeHTML(parsedHTML);
  return serializedHTML;
}

export { useAppendRootToRichTextInternalLinks as appendRootToRichTextInternalLinks };
